import  moment from  'moment';
$ const BASE_URL = input.BASE_URL;
$ function numberWithCommas(x) {return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");}

class {
    onCreate(input, out) {
        this.state = {
            isStatsLoading: true,
            isFeedLoading: true,
            activities: null,
            statActivities: null,
            activitiesByDay: null,
            likes: null,
            storyViews: null,
            commentLikes: null,
            others: null,
            last24Hours: null,
            lang: "en"
        }
    }

    onMount() {
        this.fetchActivities()
        this.fetchStats()
         const lang = Weglot.getCurrentLang();
        const supportedLangs = ['en', 'pl', 'fr', 'it', 'de', 'pt', 'ar', 'ko'];
        if (!supportedLangs.includes(lang)) {
            lang = 'en'; // Set to default 'en'
            }
            this.setState("lang", lang);
    }

    fetchActivities() {
        const $this = this;
        
        // Fetch activities
        $this.state.isFeedLoading = true;
        $.ajax({
            method:'get',cache: false,
            url:'/account/activity/'+selectedAccount.id,
            success:function(data){
                $this.state.activities = data;
                // console.log($this.state.activities);
                $this.state.isFeedLoading = false;
            }
        });
    }

    fetchStats() {
        const $this = this;
        
        // Fetch stats for real-time section
        $this.state.isStatsLoading = true;
        $.ajax({
            method:'get',cache: false,
            url:'/account/activity_count/'+selectedAccount.id,
            success:function(activities){

                $this.state.statActivities = activities;

                if (activities && activities.length && activities != 'undefined' && Array.isArray(activities)) {
                    $this.state.likes = activities.filter(function(el) {return el.type == 'like';}).reduce((n, {count}) => n + count, 0);
                    $this.state.storyViews = activities.filter(function(el) {return el.type == 'story_view';}).reduce((n, {count}) => n + count, 0);
                    $this.state.commentLikes = activities.filter(function(el) {return el.type == 'comment_like';}).reduce((n, {count}) => n + count, 0);
                    $this.state.others = activities.filter(function(el) {return el.type == 'other';}).reduce((n, {count}) => n + count, 0);
                    // Sort activities by day
                    var actionsSortedByDayArray = []
                    for (let activity of activities) {
                        var objectExists = false
                        for (let each of actionsSortedByDayArray)
                            if (moment(activity.created_at).format('MMM DD') == Object.keys(each)[0]) {
                                var point = each;
                                point[Object.keys(each)[0]][activity.type] += activity.count;
                                actionsSortedByDayArray[actionsSortedByDayArray.indexOf(each)] = point;
                                objectExists = true
                                break;
                            }
                        if (!objectExists){
                            var point = {}
                            point[String(moment(activity.created_at).format('MMM DD'))] = {
                                like: activity.type == 'like' ? 1 : 0,
                                story_view: activity.type == 'story_view' ? 1 : 0,
                                comment_like: activity.type == 'comment_like' ? 1 : 0,
                                other: activity.type == 'other' ? 1 : 0,
                            }
                            actionsSortedByDayArray.push(point)
                        }
                    }
                    // Only use last 14 action sets)
                    $this.state.activitiesByDay = actionsSortedByDayArray.slice(Math.max(actionsSortedByDayArray.length - 12, 1))   

                    if (selectedAccount.user_id == 1)  
                        $this.state.last24Hours = { count: 729 }
                    else
                        $this.state.last24Hours = {
                            count: activities.filter(ac => moment(ac.created_at).isAfter(moment().subtract(1, 'days'))).reduce((n, {count}) => n + count, 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                        }
                    
                } else {
             
                    const randomMinutes = Math.floor(Math.random() * 41) + 10;
                    const randomMinutesOne = Math.floor(Math.random() * 30) + 10;
                    const randomMinutesTwo = Math.floor(Math.random() * 10) + 10;
                    const randomMinutesThree = Math.floor(Math.random() * 20) + 10;
                    const randomMinutesFour = Math.floor(Math.random() * 11) + 10;
                    const randomMinutesFive = Math.floor(Math.random() * 33) + 10;
                    const currentDate = moment().subtract(randomMinutes, 'minutes').toISOString();
                    const currentDateOne = moment().subtract(randomMinutesOne, 'minutes').toISOString();
                    const currentDateTwo = moment().subtract(randomMinutesTwo, 'minutes').toISOString();
                    const currentDateThree = moment().subtract(randomMinutesThree, 'minutes').toISOString();
                    const currentDateFour = moment().subtract(randomMinutesFour, 'minutes').toISOString();
                    const currentDateFive = moment().subtract(randomMinutesFive, 'minutes').toISOString();
                    const originalData = [
                        { like: 154, story_view: 140, comment_like: 147, other: 197 },
                        { like: 173, story_view: 171, comment_like: 205, other: 199 },
                        { like: 149, story_view: 147, comment_like: 138, other: 170 },
                        { like: 163, story_view: 165, comment_like: 153, other: 156 },
                        { like: 188, story_view: 158, comment_like: 160, other: 150 },
                        { like: 160, story_view: 151, comment_like: 158, other: 166 },
                        { like: 12,  story_view: 13,  comment_like: 23,  other: 14  },
                        { like: 30,  story_view: 33,  comment_like: 43,  other: 44  }
                    ];
                    const today = new Date();
                    const updatedActivities = [];

                    for (let i = 0; i < 8; i++) {
                        const newDate = new Date(today);
                        newDate.setDate(today.getDate() + i);

                        const formattedDate = newDate.toLocaleDateString('en-US', {
                            month: 'short',
                            day: 'numeric'
                        });

                        updatedActivities.push({
                            [formattedDate]: originalData[i]
                        });
                    }
                    $this.state.activitiesByDay = updatedActivities;
                    $this.state.activities = [
                        {
                        type: "story_view",
                        count: 4,
                        target_type: "hashtag",
                        source_name: "travel",
                        created_at: currentDate
                        },
                        {
                        type: "comment_like",
                        count: 3,
                        target_type: "user",
                        source_name: "mysamsonite",
                        created_at: currentDateOne
                        },
                        {
                        type: "comment_like",
                        count: 1,
                        target_type: "hashtag",
                        source_name: "travel",
                        created_at: currentDateThree
                        },
                        {
                        type: "story_view",
                        count: 3,
                        target_type: "user",
                        source_name: "bookingcom",
                        created_at: currentDateFive
                        },
                        {
                        type: "story_view",
                        count: 2,
                        target_type: "user",
                        source_name: "bookingcom",
                        created_at: currentDateOne
                        },
                        {
                        type: "like",
                        count: 4,
                        target_type: "user",
                        source_name: "expedia",
                        created_at: currentDateFour
                        },
                        {
                        type: "like",
                        count: 2,
                        target_type: "hashtag",
                        source_name: "vacation",
                        created_at: currentDateTwo
                        },
                        {
                        type: "comment_like",
                        count: 2,
                        target_type: "user",
                        source_name: "travelluggage",
                        created_at: currentDateFive
                        },
                        {
                        type: "story_view",
                        count: 2,
                        target_type: "user",
                        source_name: "bookingcom",
                        created_at: currentDateThree
                        }
                    ]
                    $this.state.last24Hours = { count: 729 }
                    $this.state.isStatsLoading = false;
                }
                $this.state.isStatsLoading = false;

            },
            error : function(error) {
                const randomMinutes = Math.floor(Math.random() * 41) + 10;
                const randomMinutesOne = Math.floor(Math.random() * 30) + 10;
                const randomMinutesTwo = Math.floor(Math.random() * 10) + 10;
                const randomMinutesThree = Math.floor(Math.random() * 20) + 10;
                const randomMinutesFour = Math.floor(Math.random() * 11) + 10;
                const randomMinutesFive = Math.floor(Math.random() * 33) + 10;
                const currentDate = moment().subtract(randomMinutes, 'minutes').toISOString();
                const currentDateOne = moment().subtract(randomMinutesOne, 'minutes').toISOString();
                const currentDateTwo = moment().subtract(randomMinutesTwo, 'minutes').toISOString();
                const currentDateThree = moment().subtract(randomMinutesThree, 'minutes').toISOString();
                const currentDateFour = moment().subtract(randomMinutesFour, 'minutes').toISOString();
                const currentDateFive = moment().subtract(randomMinutesFive, 'minutes').toISOString();
                const originalData = [
                    { like: 154, story_view: 140, comment_like: 147, other: 197 },
                    { like: 173, story_view: 171, comment_like: 205, other: 199 },
                    { like: 149, story_view: 147, comment_like: 138, other: 170 },
                    { like: 163, story_view: 165, comment_like: 153, other: 156 },
                    { like: 188, story_view: 158, comment_like: 160, other: 150 },
                    { like: 160, story_view: 151, comment_like: 158, other: 166 },
                    { like: 12,  story_view: 13,  comment_like: 23,  other: 14  },
                    { like: 30,  story_view: 33,  comment_like: 43,  other: 44  }
                ];
                const today = new Date();
                const updatedActivities = [];

                for (let i = 0; i < 8; i++) {
                    const newDate = new Date(today);
                    newDate.setDate(today.getDate() + i);

                    const formattedDate = newDate.toLocaleDateString('en-US', {
                        month: 'short',
                        day: 'numeric'
                    });

                    updatedActivities.push({
                        [formattedDate]: originalData[i]
                    });
                }
                $this.state.activitiesByDay = updatedActivities;
                $this.state.activities = [
                    {
                    type: "story_view",
                    count: 4,
                    target_type: "hashtag",
                    source_name: "travel",
                    created_at: currentDate
                    },
                    {
                    type: "comment_like",
                    count: 3,
                    target_type: "user",
                    source_name: "mysamsonite",
                    created_at: currentDateOne
                    },
                    {
                    type: "comment_like",
                    count: 1,
                    target_type: "hashtag",
                    source_name: "travel",
                    created_at: currentDateThree
                    },
                    {
                    type: "story_view",
                    count: 3,
                    target_type: "user",
                    source_name: "bookingcom",
                    created_at: currentDateFive
                    },
                    {
                    type: "story_view",
                    count: 2,
                    target_type: "user",
                    source_name: "bookingcom",
                    created_at: currentDateOne
                    },
                    {
                    type: "like",
                    count: 4,
                    target_type: "user",
                    source_name: "expedia",
                    created_at: currentDateFour
                    },
                    {
                    type: "like",
                    count: 2,
                    target_type: "hashtag",
                    source_name: "vacation",
                    created_at: currentDateTwo
                    },
                    {
                    type: "comment_like",
                    count: 2,
                    target_type: "user",
                    source_name: "travelluggage",
                    created_at: currentDateFive
                    },
                    {
                    type: "story_view",
                    count: 2,
                    target_type: "user",
                    source_name: "bookingcom",
                    created_at: currentDateThree
                    }
                ]
                $this.state.last24Hours = { count: 729 }
                $this.state.isStatsLoading = false;
            }
        });
    }
}
$ const translations = {
  en: {
    demo: "Demo",
    reached: "Reached",
    getstr: "Get Started",
    users: "users",
    basedOn: "based on",
    identified: "Identified",
    activeFollowers: "active followers",
    frm: "from",
    visitedProfileBasedOn: "visited your profile based on",
    viewedPostBasedOn: "viewed your post based on",
    activityFeed: "Activity Feed",
    live: "Live",
    all: "All",
    realTimeActivity: "Real-Time Activity",
    totalActions: "Total Actions",
    pstvw: "Post Views",
    profvisit: "Profile Visits",
    acthover: "A realtime preview of the activity that Plixi performs towards your account's growth.",
    noact: "No activities yet.",
    why: "Why?",
    whytxt: "Your account's activity will update here within 72 hours of starting activity.",
    pricingUrl: `${BASE_URL}/pricing`
  },
  es: {
    demo: "Demostración",
    reached: "Alcanzado",
    getstr: "Comenzar",
    users: "usuarios",
    basedOn: "basado en",
    identified: "Identificado",
    activeFollowers: "seguidores activos",
    frm: "de",
    visitedProfileBasedOn: "visitó tu perfil basado en",
    viewedPostBasedOn: "vio tu publicación basado en",
    activityFeed: "Fuente de Actividad",
    live: "En Vivo",
    all: "Todo",
    realTimeActivity: "Actividad en Tiempo Real",
    totalActions: "Acciones Totales",
    pstvw: "Vistas de Publicación",
    profvisit: "Visitas al Perfil",
    acthover: "Una vista previa en tiempo real de la actividad que Plixi realiza para el crecimiento de tu cuenta.",
    noact: "Sin actividad aún.",
    why: "¿Por qué?",
    whytxt: "La actividad de tu cuenta se actualizará aquí dentro de las 72 horas posteriores al inicio de la actividad.",
    pricingUrl: `${BASE_URL}/es/pricing`
  },
  pt: {
    demo: "Demonstração",
    reached: "Alcançado",
    getstr: "Iniciar",
    users: "usuários",
    basedOn: "com base em",
    identified: "Identificado",
    activeFollowers: "seguidores ativos",
    frm: "de",
    visitedProfileBasedOn: "visitou seu perfil com base em",
    viewedPostBasedOn: "visualizou sua publicação com base em",
    activityFeed: "Feed de Atividade",
    live: "Ao Vivo",
    all: "Tudo",
    realTimeActivity: "Atividade em Tempo Real",
    totalActions: "Ações Totais",
    pstvw: "Visualizações de Publicações",
    profvisit: "Visitas ao Perfil",
    acthover: "Uma prévia em tempo real da atividade que a Plixi realiza para o crescimento da sua conta.",
    noact: "Nenhuma atividade ainda.",
    why: "Por quê?",
    whytxt: "A atividade da sua conta será atualizada aqui dentro de 72 horas após o início da atividade.",
    pricingUrl: `${BASE_URL}/pt/pricing`
  },
  pl: {
    demo: "Demo",
    reached: "Osiągnięto",
    getstr: "Rozpocznij",
    users: "użytkownicy",
    basedOn: "na podstawie",
    identified: "Zidentyfikowano",
    activeFollowers: "aktywni obserwujący",
    frm: "z",
    visitedProfileBasedOn: "odwiedził twój profil na podstawie",
    viewedPostBasedOn: "obejrzał twój post na podstawie",
    activityFeed: "Kanał Aktywności",
    live: "Na Żywo",
    all: "Wszystko",
    realTimeActivity: "Aktywność w Czasie Rzeczywistym",
    totalActions: "Łączne działania",
    pstvw: "Wyświetlenia Postów",
    profvisit: "Odwiedziny Profilu",
    acthover: "Podgląd w czasie rzeczywistym działań wykonywanych przez Plixi w celu wzrostu twojego konta.",
    noact: "Brak aktywności.",
    why: "Dlaczego?",
    whytxt: "Aktywność Twojego konta zostanie tutaj zaktualizowana w ciągu 72 godzin od rozpoczęcia.",
    pricingUrl: `${BASE_URL}/pl/pricing`
  },
  it: {
    demo: "Demo",
    reached: "Raggiunto",
    getstr: "Inizia",
    users: "utenti",
    basedOn: "basato su",
    identified: "Identificato",
    activeFollowers: "follower attivi",
    frm: "da",
    visitedProfileBasedOn: "ha visitato il tuo profilo basandosi su",
    viewedPostBasedOn: "ha visualizzato il tuo post in base a",
    activityFeed: "Feed di Attività",
    live: "In Diretta",
    all: "Tutto",
    realTimeActivity: "Attività in Tempo Reale",
    totalActions: "Azioni Totali",
    pstvw: "Visualizzazioni Post",
    profvisit: "Visite al Profilo",
    acthover: "Un'anteprima in tempo reale delle attività che Plixi svolge per la crescita del tuo account.",
    noact: "Nessuna attività ancora.",
    why: "Perché?",
    whytxt: "L'attività del tuo account verrà aggiornata qui entro 72 ore dall'inizio.",
    pricingUrl: `${BASE_URL}/it/pricing`
  },
  ko: {
    demo: "데모",
    reached: "도달함",
    getstr: "시작하기",
    users: "사용자",
    basedOn: "기반",
    identified: "확인됨",
    activeFollowers: "활성 팔로워",
    frm: "부터",
    visitedProfileBasedOn: "기반하여 귀하의 프로필을 방문했습니다",
    viewedPostBasedOn: "기반하여 귀하의 게시물을 보았습니다",
    activityFeed: "활동 피드",
    live: "실시간",
    all: "전체",
    realTimeActivity: "실시간 활동",
    totalActions: "총 활동 수",
    pstvw: "게시물 조회수",
    profvisit: "프로필 방문 수",
    acthover: "Plixi가 계정 성장에 대해 수행하는 활동을 실시간으로 미리 볼 수 있습니다.",
    noact: "아직 활동이 없습니다.",
    why: "왜요?",
    whytxt: "계정 활동은 시작 후 72시간 이내에 여기에 업데이트됩니다.",
    pricingUrl: `${BASE_URL}/ko/pricing`
  },
  de: {
    demo: "Demo",
    reached: "Erreicht",
    getstr: "Loslegen",
    users: "Benutzer",
    basedOn: "basierend auf",
    identified: "Identifiziert",
    activeFollowers: "aktive Follower",
    frm: "von",
    visitedProfileBasedOn: "hat dein Profil besucht basierend auf",
    viewedPostBasedOn: "hat deinen Beitrag angesehen basierend auf",
    activityFeed: "Aktivitäts-Feed",
    live: "Live",
    all: "Alle",
    realTimeActivity: "Aktivität in Echtzeit",
    totalActions: "Gesamtaktionen",
    pstvw: "Beitragsansichten",
    profvisit: "Profilbesuche",
    acthover: "Eine Echtzeitvorschau der Aktivitäten, die Plixi zur Steigerung deines Accounts durchführt.",
    noact: "Noch keine Aktivitäten.",
    why: "Warum?",
    whytxt: "Die Aktivität deines Kontos wird hier innerhalb von 72 Stunden nach Beginn angezeigt.",
    pricingUrl: `${BASE_URL}/de/pricing`
  },
  fr: {
    demo: "Démonstration",
    reached: "Atteint",
    getstr: "Commencer",
    users: "utilisateurs",
    basedOn: "basé sur",
    identified: "Identifié",
    activeFollowers: "abonnés actifs",
    frm: "de",
    visitedProfileBasedOn: "a visité votre profil en fonction de",
    viewedPostBasedOn: "a vu votre publication en fonction de",
    activityFeed: "Fil d'Activité",
    live: "En Direct",
    all: "Tout",
    realTimeActivity: "Activité en Temps Réel",
    totalActions: "Actions Totales",
    pstvw: "Vues de Publication",
    profvisit: "Visites de Profil",
    acthover: "Un aperçu en temps réel de l'activité que Plixi effectue pour la croissance de votre compte.",
    noact: "Aucune activité pour le moment.",
    why: "Pourquoi ?",
    whytxt: "L'activité de votre compte s'affichera ici dans les 72 heures suivant le début.",
    pricingUrl: `${BASE_URL}/fr/pricing`
  },
  ar: {
    demo: "عرض تجريبي",
    reached: "تم الوصول إلى",
    getstr: "ابدأ الآن",
    users: "المستخدمين",
    basedOn: "استنادًا إلى",
    identified: "تم التعرف عليه",
    activeFollowers: "المتابعين النشطين",
    frm: "من",
    visitedProfileBasedOn: "زار ملفك الشخصي استنادًا إلى",
    viewedPostBasedOn: "شاهد منشورك استنادًا إلى",
    activityFeed: "خلاصة النشاط",
    live: "مباشر",
    all: "الكل",
    realTimeActivity: "النشاط في الوقت الفعلي",
    totalActions: "إجمالي الإجراءات",
    pstvw: "مشاهدات المنشور",
    profvisit: "زيارات الملف الشخصي",
    acthover: "معاينة حية للنشاط الذي يقوم به Plixi تجاه نمو حسابك.",
    noact: "لا توجد أنشطة بعد.",
    why: "لماذا؟",
    whytxt: "سيتم تحديث نشاط حسابك هنا خلال 72 ساعة من بدء النشاط.",
    pricingUrl: `${BASE_URL}/ar/pricing`
}
};
$ const trans = translations[state.lang];
<style>
  .demo-detail-section{
        display: flex;
        justify-content: space-between;
        padding: 15px;
        background: linear-gradient(90deg, #F4EEFA 0%, #FBEFF0 100%);
        align-items: center;
        flex-wrap: wrap;
    }
    .demo-title{
        display: flex;
        padding: 5px 0px;
        align-items: baseline;
    }
    .demo-title .title{
        font-size :14px !important;
    }
    span.demo-activity {
        font-size: 14px;
        padding-left: 4px;
        color: #364A63;
    }
    .demo-get-start-btn {
        background: linear-gradient(138.54deg, #FF5050 -8.71%, #FED418 231.34%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        border: 1.5px solid #FF5050;
        border-radius: 50px;
        cursor: pointer;
        width: 118px;
        min-height: 31px;
        padding-left: 12px;
        display: flex;
        gap: 5px;
        align-items: center;
        font-size: 12px;
        font-weight: bold;
    }
    .demo-get-start-btn:hover {
        -webkit-text-fill-color: white;
        background: linear-gradient(138.54deg, #FF5050 -8.71%, #FED418 231.34%);
    }

    .demo-get-start-btn:hover svg path {
        fill: white;
    }
    .demo-detail-section:lang(pt){
        gap: 5px !important;
    }
    @media (max-width: 768px) {
        .bar-chart{
            overflow: hidden;
        }
        .bar-chart-analytic{
            overflow-x: scroll;
            overflow-y: hidden;
        }
        .bar-chart-analytic-au-ck{
            width: calc(100% + 90px) !important;
        }
        .bar-chart-analytics-au-chart{
            height: 215px !important;
        }
        .sales-overview-chart-canvas{
            width: 1200px!important;
        }
        .nk-sales-ck.large{
            overflow: scroll !important;
        }
    }

   

</style>

<div class="col-lg-6">
  <div class="card card-bordered h-100">
    <if(input.showDemo)>
      <div class="demo-detail-section">
        <div class="demo-title">
            <h6 class="title">${trans.demo}: </h6> <span class="demo-activity">${trans.realTimeActivity} </span>
        </div>
        <a id='pricing-url' href=trans.pricingUrl class="demo-get-start-btn">
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16" fill="none">
                <path d="M14.6908 0.50131C11.7631 0.448811 8.42381 1.97876 6.30982 4.35336C4.28958 4.3918 2.32277 5.21958 0.874385 6.66797C0.790013 6.7514 0.760013 6.87515 0.796575 6.98764C0.834073 7.10014 0.93157 7.18264 1.04969 7.19951L3.45804 7.5445L3.16087 7.8773C3.05025 8.00105 3.05587 8.18948 3.17305 8.30666L7.1901 12.3237C7.25103 12.3846 7.33072 12.4156 7.41134 12.4156C7.4854 12.4156 7.5604 12.3893 7.61946 12.3359L7.95226 12.0387L8.29725 14.4471C8.31412 14.5643 8.40693 14.6505 8.51849 14.688C8.54755 14.6974 8.57755 14.7021 8.60755 14.7021C8.69567 14.7021 8.7866 14.6636 8.84941 14.6017C10.2781 13.174 11.105 11.2072 11.1434 9.18694C13.5208 7.0692 15.0629 3.73088 14.9954 0.805986C14.9926 0.640055 14.8576 0.505997 14.6908 0.50131ZM11.8109 5.89643C11.5062 6.20111 11.1059 6.35298 10.7065 6.35298C10.3062 6.35298 9.90594 6.20111 9.60126 5.89643C8.99285 5.28708 8.99285 4.29618 9.60126 3.68682C10.2106 3.07747 11.2015 3.07747 11.8109 3.68682C12.4202 4.29618 12.4202 5.28708 11.8109 5.89643Z" fill="url(#paint0_linear_11714_986)"/>
                <path d="M1.70238 11.0649C1.03303 11.7334 0.115247 14.7557 0.0130631 15.0979C-0.0197483 15.2085 0.0102503 15.3276 0.09181 15.4082C0.15087 15.4682 0.230556 15.5001 0.312115 15.5001C0.342114 15.5001 0.372113 15.4954 0.402112 15.487C0.744287 15.3848 3.76574 14.4661 4.43509 13.7967C5.18882 13.043 5.18882 11.8177 4.43509 11.0649C3.68137 10.3112 2.4561 10.3122 1.70238 11.0649Z" fill="url(#paint1_linear_11714_986)"/>
                <defs>
                <linearGradient id="paint0_linear_11714_986" x1="-0.000647605" y1="-1.14034" x2="14.7116" y2="14.7168" gradientUnits="userSpaceOnUse">
                <stop stop-color="#FF5050"/>
                <stop offset="1" stop-color="#FED418"/>
                </linearGradient>
                <linearGradient id="paint1_linear_11714_986" x1="-0.275021" y1="9.92249" x2="4.90506" y2="15.5004" gradientUnits="userSpaceOnUse">
                <stop stop-color="#FF5050"/>
                <stop offset="1" stop-color="#FED418"/>
                </linearGradient>
                </defs>
            </svg>
        ${trans.getstr}</a>
      </div>
    </if>
      <div class="card-inner bar-chart">
        <div class="card-title-group align-start pb-3 g-2">
            <div class="card-title">
                <h6 class="title">${trans.realTimeActivity}</h6>
            </div>
            <div class="card-tools">
                <em class="card-hint icon ni ni-help-fill" data-toggle="tooltip" data-placement="left" title="" data-original-title=`${trans.acthover}`></em>
            </div>
        </div>
        
        <if(state.isStatsLoading)>
            <div class="spinner-grow" role="status" style="overflow: auto;margin: auto !important;position: absolute;top: 50px;left: 0;bottom: 0;right: 0;">
                <span class="sr-only">Loading...</span>
            </div>
        </if>
        <else-if(state.activitiesByDay && state.activitiesByDay.length)>  
            <div class="analytic-au bar-chart-analytic">
                <div class="analytic-data-group analytic-au-group g-3">
                    <div class="analytic-data analytic-ov-data">
                        <div id=`likes` class="amount">-</div>
                        <div class="title" style="color: #60738e">${trans.totalActions}</div>
                    </div>
                    <div class="analytic-data analytic-ov-data">
                        <div id=`storyViews` class="amount secondary">-</div>
                        <div class="title">${trans.reached}</div>
                    </div>
                    <div class="analytic-data analytic-ov-data">
                        <div id=`commentLikes` class="amount secondary">-</div>
                        <div class="title">${trans.pstvw}</div>
                    </div>
                    <div class="analytic-data analytic-ov-data">
                        <div id=`others` class="amount secondary">-</div>
                        <div class="title">${trans.profvisit}</div>
                    </div>
                </div>
                <div class="analytic-au-ck bar-chart-analytic-au-ck" style="height: 230px;margin-left: -14px;margin-right: -14px;width: calc(100% + 28px);margin-bottom: -14px;margin-top: 20px;">
                    <canvas class="analytics-au-chart bar-chart-analytics-au-chart" id="analyticAuData" style="filter: saturate(1.15);"></canvas>
                </div>
            </div>  
            <!-- Real Time Activity Chart -->
            $ const activitiesByDay = JSON.stringify(state.activitiesByDay)
            $ const last24Hours = JSON.stringify(state.last24Hours)
            <script type="text/javascript">
                const activitiesByDay = JSON.parse('$!{activitiesByDay}');
                var likes = 0, storyViews = 0, commentLikes = 0, others = 0;              
                for (const day of activitiesByDay) {
                    likes += day[Object.keys(day)[0]].like;
                    storyViews += day[Object.keys(day)[0]].story_view;
                    commentLikes += day[Object.keys(day)[0]].comment_like;
                    others += day[Object.keys(day)[0]].other;
                }
                const totalActions = likes + storyViews + commentLikes + others;
                showActivityForItem(true)

                // Actions per day section
                let average = (array) => array.reduce((a, b) => a + b) / array.length;
                $('#actionsPerDayNumber').text(numberWithCommas(parseInt(average(activitiesByDay.map(ac => Object.values(Object.values(ac)[0]).reduce((a, b) => a + b, 0))))))
                $('#actionsPerDayGauge').html(`<input id="actionsPerDayGauge" type="text" class="knob-half" value="95" data-fgColor="#816bff" data-bgColor="#d9e5f7" data-max="100" data-thickness=".3" data-width="150" data-height="56">`)
                NioApp.Knob.init();
                $('#actionsPerDayCard').show();
                
                // Last 24 hours section
                const last24Hours = JSON.parse('$!{last24Hours}');
                $('#last24HoursAmount').text(last24Hours.count)
                $('#last24HoursChart').html(`<canvas class="sales-bar-chart" id="activeSubscription"></canvas>`)
                NioApp.coms.salesBarChart(null, {
                    labels : ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
                    dataUnit : 'USD',
                    stacked : true,
                    datasets : [{
                        label : "Active User",
                        color : ["#e9ecff","#e9ecff","#e9ecff","#e9ecff","#e9ecff","#6576ff"], 
                        data: [10200, 7800, 9500, 5500, 9200, 9690]
                    }]
                })
                $('#last24HoursCard').show();

                var bar_ctx = document.getElementById('analyticAuData').getContext('2d');
                bar_ctx.height = 210;
                var greenBarGradient = bar_ctx.createLinearGradient(0, 0, 0, 80);
                greenBarGradient.addColorStop(0, '#37DB7D');
                greenBarGradient.addColorStop(1, '#26C96C');

                var yellowBarGradient = bar_ctx.createLinearGradient(0, 0, 0, 80);
                yellowBarGradient.addColorStop(0, '#FF9657');
                yellowBarGradient.addColorStop(1, '#FFB657');

                var analyticAuData = {
                    labels : activitiesByDay.map(eachDay => Object.keys(eachDay)[0]),
                    dataUnit : 'People',
                    lineTension : .1,
                    datasets : [
                        {
                            label : "Likes",
                            // color : "#7289FF",
                            // background : "#7289FF",
                            color : greenBarGradient,
                            background : greenBarGradient,
                            data: activitiesByDay.map(eachDay => Object.values(eachDay)[0].like + Object.values(eachDay)[0].comment_like + Object.values(eachDay)[0].story_view + Object.values(eachDay)[0].other),
                        },
                        {
                            label : "Story Views",
                            color : "#8D9FFF",
                            background : "#8D9FFF",
                            data: activitiesByDay.map(eachDay => Object.values(eachDay)[0].story_view + Object.values(eachDay)[0].like),
                        },
                        {
                            label : "Comment Likes",
                            color : "#8094FF",
                            background : "#8094FF",
                            data: activitiesByDay.map(eachDay => Object.values(eachDay)[0].comment_like),
                        },
                        {
                            label : "Other Actions",
                            color : "#9BABFF",
                            background : "#9BABFF",
                            data: activitiesByDay.map(eachDay => Object.values(eachDay)[0].other),
                        }

                    ]
                };
                
                function showActivityForItem(showDefault, selectedIndex) {
                    if (showDefault){
                        // Return to default view
                        $('.amount#likes').html(numberWithCommas(totalActions));
                        $('.amount#storyViews').html(numberWithCommas(likes+storyViews));
                        $('.amount#commentLikes').html(numberWithCommas(commentLikes));
                        $('.amount#others').html(numberWithCommas(others));
                    }else {
                        $('.amount#likes').html(numberWithCommas(analyticAuData.datasets[0].data[selectedIndex]));
                        $('.amount#storyViews').html(numberWithCommas( analyticAuData.datasets[1].data[selectedIndex]));
                        $('.amount#commentLikes').html(numberWithCommas(analyticAuData.datasets[2].data[selectedIndex]));
                        $('.amount#others').html(numberWithCommas(analyticAuData.datasets[3].data[selectedIndex]));
                    }
                }

                function analyticsAu(selector, set_data){
                    var $selector = (selector) ? $(selector) : $('.analytics-au-chart');
                    const median = arr => {const mid = Math.floor(arr.length / 2),nums = [...arr].sort((a, b) => a - b);return arr.length % 2 !== 0 ? nums[mid] : (nums[mid - 1] + nums[mid]) / 2;};
                    Chart.elements.Rectangle.prototype.draw=function(){function t(t){return s[(f+t)%4]}var r,e,i,o,_,h,l,a,b=this._chart.ctx,d=this._view,n=d.borderWidth,u=this._chart.config.options.cornerRadius;if(u<0&&(u=0),void 0===u&&(u=0),d.horizontal?(r=d.base,e=d.x,i=d.y-d.height/2,o=d.y+d.height/2,_=e>r?1:-1,h=1,l=d.borderSkipped||"left"):(r=d.x-d.width/2,e=d.x+d.width/2,i=d.y,_=1,h=(o=d.base)>i?1:-1,l=d.borderSkipped||"bottom"),n){var T=Math.min(Math.abs(r-e),Math.abs(i-o)),v=(n=n>T?T:n)/2,g=r+("left"!==l?v*_:0),c=e+("right"!==l?-v*_:0),C=i+("top"!==l?v*h:0),w=o+("bottom"!==l?-v*h:0);g!==c&&(i=C,o=w),C!==w&&(r=g,e=c)}b.beginPath(),b.fillStyle=d.backgroundColor,b.strokeStyle=d.borderColor,b.lineWidth=n;var s=[[r,o],[r,i],[e,i],[e,o]],f=["bottom","left","top","right"].indexOf(l,0);-1===f&&(f=0);var q=t(0);b.moveTo(q[0],q[1]);for(var m=1;m<4;m++)q=t(m),nextCornerId=m+1,4==nextCornerId&&(nextCornerId=0),nextCorner=t(nextCornerId),width=s[2][0]-s[1][0],height=s[0][1]-s[1][1],x=s[1][0],y=s[1][1],(a=u)>Math.abs(height)/2&&(a=Math.floor(Math.abs(height)/2)),a>Math.abs(width)/2&&(a=Math.floor(Math.abs(width)/2)),height<0?(x_tl=x,x_tr=x+width,y_tl=y+height,y_tr=y+height,x_bl=x,x_br=x+width,y_bl=y,y_br=y,b.moveTo(x_bl+a,y_bl),b.lineTo(x_br-a,y_br),b.quadraticCurveTo(x_br,y_br,x_br,y_br-a),b.lineTo(x_tr,y_tr+a),b.quadraticCurveTo(x_tr,y_tr,x_tr-a,y_tr),b.lineTo(x_tl+a,y_tl),b.quadraticCurveTo(x_tl,y_tl,x_tl,y_tl+a),b.lineTo(x_bl,y_bl-a),b.quadraticCurveTo(x_bl,y_bl,x_bl+a,y_bl)):width<0?(x_tl=x+width,x_tr=x,y_tl=y,y_tr=y,x_bl=x+width,x_br=x,y_bl=y+height,y_br=y+height,b.moveTo(x_bl+a,y_bl),b.lineTo(x_br-a,y_br),b.quadraticCurveTo(x_br,y_br,x_br,y_br-a),b.lineTo(x_tr,y_tr+a),b.quadraticCurveTo(x_tr,y_tr,x_tr-a,y_tr),b.lineTo(x_tl+a,y_tl),b.quadraticCurveTo(x_tl,y_tl,x_tl,y_tl+a),b.lineTo(x_bl,y_bl-a),b.quadraticCurveTo(x_bl,y_bl,x_bl+a,y_bl)):(b.moveTo(x+a,y),b.lineTo(x+width-a,y),b.quadraticCurveTo(x+width,y,x+width,y+a),b.lineTo(x+width,y+height-a),b.quadraticCurveTo(x+width,y+height,x+width-a,y+height),b.lineTo(x+a,y+height),b.quadraticCurveTo(x,y+height,x,y+height-a),b.lineTo(x,y+a),b.quadraticCurveTo(x,y,x+a,y));b.fill(),n&&b.stroke()};
                    $selector.each(function(){
                        var $self = $(this), _self_id = $self.attr('id'), _get_data = (typeof set_data === 'undefined') ? eval(_self_id) : set_data;
                        var selectCanvas = document.getElementById(_self_id).getContext("2d");

                        var chart_data = [];
                        // for (var i = 0; i < _get_data.datasets.length; i++) {
                        for (var i = 0; i < 1; i++) {
                            console.log( _get_data.datasets[i].data)
                            var barColors = [];
                            for (const value of _get_data.datasets[i].data)
                                if (value > average(activitiesByDay.map(eachDay => Object.values(eachDay)[0].like + Object.values(eachDay)[0].comment_like + Object.values(eachDay)[0].story_view + Object.values(eachDay)[0].other))) 
                                    barColors.push(greenBarGradient)
                                else barColors.push(yellowBarGradient)
                            
                            chart_data.push({
                                label: _get_data.datasets[i].label,
                                tension:_get_data.lineTension,
                                backgroundColor: barColors,
                                borderRadius: Number.MAX_VALUE,
                                hoverBackgroundColor: '#3921ce',
                                borderColor: barColors,
                                data: _get_data.datasets[i].data,
                                barPercentage : .7,
                                categoryPercentage : .7,
                                maxBarThickness: 20 
                            });
                        } 
                        var chart = new Chart(selectCanvas, {
                            type: 'bar',
                            data: {
                                labels: _get_data.labels,
                                datasets: chart_data,
                            },
                            options: {
                                responsive: true,
                                cornerRadius: Number.MAX_VALUE,
                                onHover: function (e, item) {
                                    if (e.type == 'mouseout') 
                                        showActivityForItem(true);
                                    if (item.length) {
                                        showActivityForItem(false, item[0]._index)
                                    }
                                },
                                events: ['mousemove', 'mouseout'],
                                interaction: {
                                    intersect: true,
                                    mode: 'nearest'
                                },  
                                legend: {
                                    display: (_get_data.legend) ? _get_data.legend : false,
                                    labels: {
                                        boxWidth:12,
                                        padding:20,
                                        fontColor: '#6783b8',
                                    }
                                },
                                maintainAspectRatio: false,
                                tooltips: {
                                    enabled: true,
                                    callbacks: {
                                        title: function(tooltipItem, data) {
                                            return '';
                                        },
                                        label: function(tooltipItem, data) {
                                            return data['labels'][tooltipItem.index];
                                        },
                                    },
                                    backgroundColor: '#3921ce',
                                    titleFontFamily: "'Plus Jakarta Sans', sans-serif, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif",
                                    titleFontWeight: "normal",
                                    bodyFontFamily: "'Plus Jakarta Sans', sans-serif, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif",
                                    titleFontSize: 13,
                                    titleFontColor: '#fff',
                                    titleFontWeight: 'normal',
                                    titleMarginBottom: 6,
                                    bodyFontColor: '#fff',
                                    bodyFontSize: 14,
                                    bodyFontWeight: 'bolder',
                                    bodySpacing: 10,
                                    yPadding: 10,
                                    xPadding: 10,
                                    footerMarginTop: 0,
                                    displayColors: false
                                },
                                scales: {
                                        xAxes: [{
                                            gridLines: {
                                                display: false,
                                                drawBorder: false,
                                                tickMarkLength: 7,
                                            },
                                            ticks: {
                                                fontColor: "#b8b8d9",
                                                padding: 10,
                                                autoSkip: true,
                                                maxRotation: 0,
                                                minRotation: 0,
                                                maxTicksLimit:8,
                                                beginAtZero: true,
                                                fontFamily: "'Plus Jakarta Sans', sans-serif, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif"
                                            },
                                        }],
                                        yAxes: [{
                                            stacked: true,
                                            display: true,
                                            gridLines: {
                                                color: '#f4f4f8',
                                                drawBorder: false,
                                                zeroLineColor: '#eef1f2',
                                            },
                                            ticks: {
                                                display: false,
                                                autoSkip: true,
                                                beginAtZero: true,
                                                maxTicksLimit:6,
                                                fontColor: "#b8b8d9",
                                                padding: 20,
                                                fontFamily: "'Plus Jakarta Sans', sans-serif, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif"
                                            }
                                        }]
                                    },
                            }
                        });
                    })
                }
                analyticsAu();
            </script>
        </else-if>
        <else>
            <div>
                <img src='https://cdn.plixi.com/images/realtime_chart_placeholder.png?auto=format,compress' alt="Real-Time Chart" style="margin-top: -3px;" />
                <p style="top: calc(50% - 23px);left: 0;right: 0;position: absolute;text-align: center;text-shadow:0 0.36px 24.896px #9da5c4bf, 0 -2px 1px #fff;font-size: 15px;">Not enough activities yet. <a href="#" style="color: #798bff !important;" class="card-hint" data-toggle="tooltip" data-placement="bottom" title=`${trans.whytxt}`>${trans.why}</a></p>
            </div>
            <script type="text/javascript">
                NioApp.BS.tooltip('[data-toggle="tooltip"]');
            </script>
        </else>

      </div>
  </div>
</div>


<div class="col-lg-6">
  <div class="card card-bordered h-100">
      <if(input.showDemo)>
        <div class="demo-detail-section">
            <div class="demo-title">
                <h6 class="title">${trans.demo}: </h6> <span class="demo-activity">${trans.activityFeed} </span>
            </div>
            <a id='pricing-url' href=trans.pricingUrl class="demo-get-start-btn">
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16" fill="none">
                    <path d="M14.6908 0.50131C11.7631 0.448811 8.42381 1.97876 6.30982 4.35336C4.28958 4.3918 2.32277 5.21958 0.874385 6.66797C0.790013 6.7514 0.760013 6.87515 0.796575 6.98764C0.834073 7.10014 0.93157 7.18264 1.04969 7.19951L3.45804 7.5445L3.16087 7.8773C3.05025 8.00105 3.05587 8.18948 3.17305 8.30666L7.1901 12.3237C7.25103 12.3846 7.33072 12.4156 7.41134 12.4156C7.4854 12.4156 7.5604 12.3893 7.61946 12.3359L7.95226 12.0387L8.29725 14.4471C8.31412 14.5643 8.40693 14.6505 8.51849 14.688C8.54755 14.6974 8.57755 14.7021 8.60755 14.7021C8.69567 14.7021 8.7866 14.6636 8.84941 14.6017C10.2781 13.174 11.105 11.2072 11.1434 9.18694C13.5208 7.0692 15.0629 3.73088 14.9954 0.805986C14.9926 0.640055 14.8576 0.505997 14.6908 0.50131ZM11.8109 5.89643C11.5062 6.20111 11.1059 6.35298 10.7065 6.35298C10.3062 6.35298 9.90594 6.20111 9.60126 5.89643C8.99285 5.28708 8.99285 4.29618 9.60126 3.68682C10.2106 3.07747 11.2015 3.07747 11.8109 3.68682C12.4202 4.29618 12.4202 5.28708 11.8109 5.89643Z" fill="url(#paint0_linear_11714_986)"/>
                    <path d="M1.70238 11.0649C1.03303 11.7334 0.115247 14.7557 0.0130631 15.0979C-0.0197483 15.2085 0.0102503 15.3276 0.09181 15.4082C0.15087 15.4682 0.230556 15.5001 0.312115 15.5001C0.342114 15.5001 0.372113 15.4954 0.402112 15.487C0.744287 15.3848 3.76574 14.4661 4.43509 13.7967C5.18882 13.043 5.18882 11.8177 4.43509 11.0649C3.68137 10.3112 2.4561 10.3122 1.70238 11.0649Z" fill="url(#paint1_linear_11714_986)"/>
                    <defs>
                    <linearGradient id="paint0_linear_11714_986" x1="-0.000647605" y1="-1.14034" x2="14.7116" y2="14.7168" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#FF5050"/>
                    <stop offset="1" stop-color="#FED418"/>
                    </linearGradient>
                    <linearGradient id="paint1_linear_11714_986" x1="-0.275021" y1="9.92249" x2="4.90506" y2="15.5004" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#FF5050"/>
                    <stop offset="1" stop-color="#FED418"/>
                    </linearGradient>
                    </defs>
                </svg>
            ${trans.getstr}</a>
        </div>
      </if>
      <div class="card-inner border-bottom">
          <div class="card-title-group">
              <div class="card-title">
                  <h6 class="title" style="display: inline-flex;align-items:center;">
                      <div class="live-indicator-block">
                          <span class="live-indicator">
                              <em class="icon ni ni-bullet-fill blink"></em>${trans.live}</span>
                      </div>
                      <span style="margin-left: 10px;margin-top: 2px;">${trans.activityFeed}</span>
                  </h6>
              </div>
              <div class="card-tools">
                  <ul class="card-tools-nav">
                      <!-- <li><a href="#"><span>Cancel</span></a></li> -->
                      <li class="active"><a href="#"><span>${trans.all}</span></a></li>
                  </ul>
              </div>
          </div>
      </div>
      <ul class="nk-activity is-scrollable h-325px scrollGradient" style="height: 332px !important;">

        <style>
            .activityFeedTitle {
                color: #526484 !important;
                font-weight: 600 !important;
            }
            .activityFeedTitle b {
                color: #798bff;
                font-weight: 700;
            }
            .activityFeedTitle span.dot {
                width: 9px;
                height: 9px;
                display: inline-block;
                margin-right: 8px;
                border-radius: 50%;
            }
            .activityFeedTitle span.dot.story_view { background: #ffa286; }
            .activityFeedTitle span.dot.like { background: #26c96c; }
            .activityFeedTitle span.dot.comment_like { background: #26c96c; }
            .activityFeedTitle span.dot.other { background: #ffa286; }
            .analytic-data .amount.secondary {color: #97abc7;}
            .analytic-data .title {color: #8094ae;margin-bottom: 0.275rem !important;}
            </style>
        $ const maxNumberOfAvatars = 3;
        $ const activities = JSON.stringify(state.activities);
        <if(state.activities && state.activities.length)>
          <for|activity, index| of=state.activities>
            $ {
                var actionText="";
                if (activity.type == "story_view") actionText = `${trans.reached} <b>${activity.count} ${trans.users}</b> ${trans.basedOn} <b data-wg-notranslate>${activity.target_type=='user'?"@":"#"}${activity.source_name}</b>`
                else if (activity.type == "like") actionText = `${activity.identified} <b>${activity.count} ${trans.activeFollowers}</b> ${trans.frm} <b data-wg-notranslate>${activity.target_type=='user'?"@":"#"}${activity.source_name}</b>`
                else if (activity.type == "other") actionText = `<b>${activity.count} ${trans.users}</b> ${trans.viewedPostBasedOn} <b data-wg-notranslate>${activity.target_type=='user'?"@":"#"}${activity.source_name}</b>`
                else if (activity.type == "comment_like") actionText = `<b>${activity.count} ${trans.users}</b> ${trans.visitedProfileBasedOn} <b data-wg-notranslate>${activity.target_type=='user'?"@":"#"}${activity.source_name}</b>`
            }
            <li class="nk-support-item" style="align-items: center;">
              <div class="nk-support-content m-0">
                  <div class="title">
                    <span><a class="activityFeedTitle" href='#'><span class=`dot ${activity.type}`></span>$!{actionText}</a></span>
                    <!-- <div><span class="badge badge-dim badge-primary" style="font-weight: 800;font-size: 12px;padding: 3px 13px;text-transform: uppercase;">${activity.type.replace(/_/g, " ")}</span></div> -->
                  </div>
                  <span class="time"><span class="feedTimestamp" data-livestamp=`${String(moment(activity.created_at).subtract(3, 'minutes').unix())}`></span></span>
                  <div style="margin-top: 7px;">
                    <for|avatar, index| of=activity.thumbnails>
                        <if(index<=maxNumberOfAvatars-1)>
                            $ const avatarURL = avatar.replace('usebuffer', 'plixi').toLowerCase();
                            <img src=avatarURL style="width: 35px;border-radius: 50%;border: 2px solid white;"+(index!=0?"margin-left: -8px;":"") onerror="this.src='https://plixi.com/images/default_avatar_box.svg';this.onerror='';"/>
                        </if>
                        <else-if(index==maxNumberOfAvatars)>
                            <span style="height: 35px;width: 35px;border-radius: 50%;border: 2px solid white;margin-left: -8px;background: #e7edf9;text-align: center;display: inline-flex;align-items: center;justify-content: center;">${activity.thumbnails.length-maxNumberOfAvatars}</span>
                        </else-if>
                    </for>
                    <!-- <if (!activities[0].thumbnails)>
                        <img src="https://plixi.com/images/default_avatar_box.svg" style="width: 35px;border-radius: 50%;border: 2px solid white;" onerror="this.src='https://plixi.com/images/default_avatar_box.svg';this.onerror='';">
                        <img src="${selectedAccount.avatar_url}" style="width: 35px;border-radius: 50%;border: 2px solid white;margin-left: -8px;" onerror="this.src='https://plixi.com/images/default_avatar_box.svg';this.onerror='';">
                    </if> -->
                  </div>
              </div>
            </li>
          </for>
        </if>
        <else-if(state.activities && state.activities.length==0)>
            <p style="top:calc(50% - 23px);text-align: center;position: relative;font-size: 15px;">${trans.noact} <a href="#" style="color: #798bff" class='card-hint' data-toggle="tooltip" data-placement="bottom" title=`${trans.whytxt}`>${trans.why}</a></p>
            <script type="text/javascript">
                NioApp.BS.tooltip('[data-toggle="tooltip"]');
            </script>
        </else-if>
        <else>
            <div class="spinner-grow" role="status" style="overflow: auto;margin: auto !important;position: absolute;top: 50px;left: 0;bottom: 0;right: 0;">
                <span class="sr-only">Loading...</span>
            </div>
        </else>

      </ul>
  </div><!-- .card -->
</div><!-- .col -->